import {AddTeam_Manager} from "../model/manager"
import {TeamToAdd} from "../model/add-team"
import {AddTeamType} from "../@const"
import Workspace from "../../../model2/space/workspaces/workspace"
import ApiProjectUser from "../../../gd/api/project-user"
import ProjectSession from "../../../model2/project/project-session"
import Task from "../../../model2/task/task"
// import ApiTask from "../../../gd/api/task"
import TeamsToAdd from "../model/collection"

// const debug = "AddTeam_createTeams"
const debug = false

export default async function AddTeam_createTeams(manager: AddTeam_Manager) {

    const selectedTeams: TeamToAdd[] = []

    selectedTeams.push(...manager.companyTeamsToAdd.selected)
    selectedTeams.push(...manager.workspaceTeamsToAdd.selected)
    selectedTeams.push(...manager.projectTeamsToAdd.selected)

    debug && console.log(debug, "process")

    if (selectedTeams.length === 0) {
        console.warn("No teams selected")
        return false
    }

    try {
        debug && console.log(debug, "Selected teams:", selectedTeams)

        switch (manager.type) {
            case AddTeamType.WORKSPACE_TEAM:
                if (!_.isEmpty(manager.companyTeamsToAdd.selected)) {
                    await AddTeam_createWorkspaceTeams(manager.workspace, manager.companyTeamsToAdd)
                }
                break

            case AddTeamType.PROJECT_TEAM:
                if (manager.workspace) {
                    if (!_.isEmpty(manager.companyTeamsToAdd.selected)) {
                        // here we need create workspace teams and then project teams
                        await AddTeam_createWorkspaceTeams(manager.workspace, manager.companyTeamsToAdd)
                        await AddTeam_createProjectTeams(manager.project, manager.companyTeamsToAdd)
                    }

                    if (manager.workspaceTeamsToAdd && !_.isEmpty(manager.workspaceTeamsToAdd.selected)) {
                        await AddTeam_createProjectTeams(manager.project, manager.workspaceTeamsToAdd)
                    }
                } else {
                    if (!_.isEmpty(manager.companyTeamsToAdd.selected)) {
                        await AddTeam_createProjectTeams(manager.project, manager.companyTeamsToAdd)
                    }
                }
                break

            /*case AddTeamType.TASK_TEAM:

                if (manager.workspace) {
                    if (!_.isEmpty(manager.companyTeamsToAdd.selected)) {
                        // here we need create workspace teams and then project teams
                        await AddTeam_createWorkspaceTeams(manager.workspace, manager.companyTeamsToAdd)
                        await AddTeam_createProjectTeams(manager.project, manager.companyTeamsToAdd)
                        await AddTeam_createTaskTeams(manager.task, manager.companyTeamsToAdd)
                    }

                    if (manager.workspaceTeamsToAdd && !_.isEmpty(manager.workspaceTeamsToAdd.selected)) {
                        await AddTeam_createProjectTeams(manager.project, manager.workspaceTeamsToAdd)
                        await AddTeam_createTaskTeams(manager.task, manager.workspaceTeamsToAdd)
                    }

                    if (manager.projectTeamsToAdd && !_.isEmpty(manager.projectTeamsToAdd.selected)) {
                        await AddTeam_createTaskTeams(manager.task, manager.projectTeamsToAdd)
                    }
                } else {
                    if (!_.isEmpty(manager.companyTeamsToAdd.selected)) {
                        await AddTeam_createProjectTeams(manager.project, manager.companyTeamsToAdd)
                        await AddTeam_createTaskTeams(manager.task, manager.companyTeamsToAdd)
                    }

                    if (manager.projectTeamsToAdd && !_.isEmpty(manager.projectTeamsToAdd.selected)) {
                        await AddTeam_createTaskTeams(manager.task, manager.projectTeamsToAdd)
                    }
                }
                break*/
        }

        return true
    } catch (error) {
        console.error("Error creating teams:", error)
        return false
    }
}

export async function AddTeam_createWorkspaceTeams(workspace?: Workspace, teamsToAdd?: TeamsToAdd) {
    if (workspace && teamsToAdd) {
        await ApiProjectUser.createWorkspaceTeams(workspace.id, teamsToAdd.selected).promise()
    }
}

export async function AddTeam_createProjectTeams(project?: ProjectSession, teamsToAdd?: TeamsToAdd) {
    if (project && teamsToAdd) {
        await ApiProjectUser.createProjectTeams(project.id, teamsToAdd.selected).promise()
    }
}

export async function AddTeam_createTaskTeams(task?: Task, teamsToAdd?: TeamsToAdd) {
    if (task?.id && teamsToAdd) {
        // await ApiTask.createTaskTeams(task.id, teamsToAdd.selected).promise()
    }
}